import type {
  ClaimTemplateListItem,
  TemplateSection,
} from '../templates/interface';

export interface Claim {
  dossier_id: string;
  client_dossier_id: string;
  dossier_name: string;
  assignee: string;
  assignee_full_name: string;
  assignee_id: string;
  manager: string;
  graph_version?: string;
  data: {
    [k: string]: string;
  };
  created_at: string;
  updated_at: string;
  status: string;
  dossierType: string;
  claimant_metadata_dict?: {
    [k: string]: {
      display_name: string;
      description: string;
      value: string;
    };
  };
}

export interface Citation {
  citation_id: string;
  file_id: string;
  file_name?: string;
  fragment_type?: string; // CITATION | NOTE | ...
  pages: [number, number];
  start_page?: number;
  end_page?: number;
}

export interface ClaimSummaryFeedback {
  dossier_summary_feedback_id: string;
  dossier_summary_id: string;
  feedback_reason: string;
  feedback_reason_detail: string;
  set_by_user_email: string;
  created_at: string;
  updated_at: string;
}

export interface ClaimSummary {
  dossier_summary_id: string;
  dossier_id: string;
  content: string;
  citations: Citation[];
  dossier_summary_type: string;
  summary_order: number;
  created_at: string;
  updated_at: string;
}

export interface Insight {
  insight_id: string;
  question: string;
  answer: string;
  title: string;
}

export interface AudioTranscript {
  summary: string;
  speakers: string[];
  transcript: {
    text: string;
    speaker: string;
  }[];
}

export interface Summary {
  summary_id: string;
  question: string;
  answer: string;
  title: string;
  group?: string;
}

export enum AGENTIC_VERBS {
  Expand = 'EXPAND',
}

export enum ParticipantType {
  PERSON = 'PERSON',
  ORGANIZATION = 'ORGANIZATION',
}

export interface Participant {
  name: string;
  type: ParticipantType;
}

export interface Thread {
  thread_id: string;
  dossier_id: string;
  thread_name: string;
  created_at: string;
  updated_at: string;
}

export interface Message {
  message_id: string;
  thread_id: string;
  role: string;
  message: {
    content: string;
  };
  created_at: string;
}

export type SummaryTemplate = {
  data: {
    hydrated_schema: TemplateSection[];
    color_config: Record<string, string>;
  };
} & ClaimTemplateListItem;

export type InsightTemplate = SummaryTemplate;
